import { IGetAllFormularioAvaliacaoUseCase } from "../../../presentation/useCases/read/get_all_medicao_formulario_avaliacao_use_case";
import { FormularioAvaliacaoLista } from "../../models/formulario_avaliacao_lista";
import { ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";



export class GetAllFormularioAvaliacaoUseCase implements IGetAllFormularioAvaliacaoUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) { }

  async getAllFormularioAvaliacao(
    IdMedicaoTerceirizacao: number
  ): Promise<FormularioAvaliacaoLista> {
    const result = await this.repository.getAllFormularioAvaliacao(IdMedicaoTerceirizacao);
    if (result === null) throw new Error('Falha ao buscar avaliaçãa!');
    return result;
  }
}
